var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bingo-card h-1/5 w-1/5",class:_vm.classes,style:(_vm.styles),on:{"click":_vm.toggleActive}},[_c('div',{staticClass:"bingo-card__overlay",style:({backgroundColor: _vm.config.color})})])}
var staticRenderFns = []

export { render, staticRenderFns }